import $ from 'jquery';
import { init } from './lib';

window.addEventListener('load', init($).run);
